export default "__VITE_ASSET__LjNdo0ay__"